import React, { useState, useEffect } from 'react';

function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Show banner after a short delay for better UX
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
    // In a real app, you would disable non-essential cookies here
  };

  if (!showBanner) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: '#2D3748',
      color: '#FFFFFF',
      padding: '20px',
      boxShadow: '0 -4px 16px rgba(0,0,0,0.2)',
      zIndex: 9999,
      animation: 'slideUp 0.3s ease-out'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: window.innerWidth < 768 ? 'column' : 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px'
      }}>
        <div style={{ flex: 1 }}>
          <p style={{
            margin: 0,
            fontSize: '14px',
            lineHeight: '1.6',
            color: '#E2E8F0'
          }}>
            We use cookies only to maintain your login session and remember your cookie preferences.
            We do NOT track or analyze your usage. By clicking "Accept", you consent to our use of cookies.
            For more information, please see our{' '}
            <a
              href="/privacy"
              target="_blank"
              style={{
                color: '#81E6D9',
                textDecoration: 'underline',
                fontWeight: '500'
              }}
            >
              Privacy Policy
            </a>.
          </p>
        </div>

        <div style={{
          display: 'flex',
          gap: '12px',
          flexShrink: 0
        }}>
          <button
            onClick={handleDecline}
            style={{
              padding: '10px 24px',
              fontSize: '14px',
              fontWeight: '600',
              background: 'transparent',
              color: '#E2E8F0',
              border: '2px solid #E2E8F0',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'all 0.2s',
              whiteSpace: 'nowrap'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#4A5568';
              e.target.style.borderColor = '#FFFFFF';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'transparent';
              e.target.style.borderColor = '#E2E8F0';
            }}
          >
            Decline
          </button>

          <button
            onClick={handleAccept}
            style={{
              padding: '10px 24px',
              fontSize: '14px',
              fontWeight: '600',
              background: '#2B634B',
              color: '#FFFFFF',
              border: '2px solid #2B634B',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'all 0.2s',
              whiteSpace: 'nowrap'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#235239';
              e.target.style.borderColor = '#235239';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#2B634B';
              e.target.style.borderColor = '#2B634B';
            }}
          >
            Accept Cookies
          </button>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}

export default CookieConsent;
